import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import { IBannerData, ISurgicalData } from "../../exports/interfaces";
import {
  fetchFacialPlasticSurgery,
  fetchFacialPlasticSurgeryBanner,
} from "../../api/SurgicalDomainApi";
import { dynamicFailed } from "../../hooks/useToast";
import SurgicalDomainsDescription from "../../components/surgicaldomains/SurgicalDomainsDescription";
import SurgicalDomainsBanner from "../../components/surgicaldomains/SurgicalDomainsBanner";

const FacialPlasticSurgery = () => {
  const { setLoading } = useLoader();
  const [facialPlasticSurgeryBanner, setfacialPlasticSurgeryBanner] = useState<
    IBannerData[]
  >([]);
  const [facialPlasticSurgeryData, setFacialPlasticSurgeryData] = useState<
    ISurgicalData[]
  >([]);

  useEffect(() => {
    setLoading(true);
    // Promise.all([fetchArchiveBanner(), fetchVideoData()])
    Promise.all([
      fetchFacialPlasticSurgeryBanner(),
      fetchFacialPlasticSurgery(),
    ])
      .then(([facialPlasticSurgeryBannerData, facialPlasticSurgeryData]) => {
        setfacialPlasticSurgeryBanner(facialPlasticSurgeryBannerData);
        setFacialPlasticSurgeryData(facialPlasticSurgeryData);
        // setArchiveVideoData(videoData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <SurgicalDomainsBanner
        bannerData={facialPlasticSurgeryBanner}
        page={"Types of facial plastic Surgery"}
      />
      <SurgicalDomainsDescription descriptionData={facialPlasticSurgeryData} />
    </>
  );
};

export default FacialPlasticSurgery;
